import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { Form } from '../../../../components/general/general-component/abstruct-component/AbstructForm';
import { VariableAccountType } from './VariableAccountType';
import { postAccountType } from '../../../../store/Actions/ActionAccountType';

function AddAccountType({ open, setOpen }) {
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad } = VariableAccountType();
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postAccountType(state, setLoad));
    };

    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('add_account_type')}</p>
                </div>
                <div style={{marginTop: "-10px"}} >
                    <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
                </div>
            </div>
        </RModal>
    );
}

export default AddAccountType;
